import { FieldFilter } from 'module/types/filter-field/filter';
import { Space, Typography } from 'antd';
import styled from 'styled-components';
import { ValueRenderer } from './value-renderer';

const { Text } = Typography;

const StyledText = styled(Text)`
  max-width: var(--width-md);
`;

export const SelectedConditions = ({
  criteria = [],
  customOptionTrigger,
}: {
  criteria?: FieldFilter[];
  customOptionTrigger?: boolean;
}) => {
  const safeCriteria: FieldFilter[] = (criteria ?? []).filter((criterion) =>
    Boolean(criterion.field),
  );

  return (
    <Space direction="vertical">
      {safeCriteria.map((each) => (
        <Space key={each.field.fieldId} align="center">
          <StyledText strong ellipsis={{ tooltip: true }}>
            {each.field.fieldName}
          </StyledText>
          <ValueRenderer
            selected={each}
            customOptionTrigger={customOptionTrigger}
          />
        </Space>
      ))}
    </Space>
  );
};
